import script from "./roomReservation.vue?vue&type=script&setup=true&lang=js"
export * from "./roomReservation.vue?vue&type=script&setup=true&lang=js"

import "./roomReservation.vue?vue&type=style&index=0&id=9ab6f31e&lang=less&scoped=true"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ab6f31e"]])

export default __exports__